import React from 'react';
import { Row, Col, Button, Badge, Spinner } from 'react-bootstrap';
import { IconChevronLeft, IconBuildingStore, IconDeviceFloppy } from '@tabler/icons-react';

const DesktopHeader = ({ 
  isEditing, 
  onCancel, 
  onSaveDraft, 
  draftLoading 
}) => {
  return (
    <div className="mpf-desktop-header d-none d-md-block mb-4">
      <Row className="align-items-center">
        <Col>
          <div className="d-flex align-items-center">
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={onCancel}
              className="me-3"
            >
              <IconChevronLeft size={16} className="me-1" />
              Voltar
            </Button>
            
            <div>
              <h1 className="h3 mb-1 fw-bold">
                <IconBuildingStore size={24} className="text-primary me-2" />
                {isEditing ? "Editar Publicação" : "Nova Publicação"}
                {isEditing && (
                  <Badge bg="warning" className="ms-2">Modo Edição</Badge>
                )}
              </h1>
              <p className="text-muted mb-0">
                {isEditing
                  ? "Atualize as informações da sua publicação no marketplace"
                  : "Publique seu agente no marketplace para outros usuários"}
              </p>
            </div>
          </div>
        </Col>
        
        <Col xs="auto">
          {!isEditing && (
            <Button
              variant="outline-primary"
              size="sm"
              onClick={onSaveDraft}
              disabled={draftLoading}
            >
              {draftLoading ? (
                <Spinner size="sm" className="me-1" />
              ) : (
                <IconDeviceFloppy size={16} className="me-1" />
              )}
              Salvar Rascunho
            </Button>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DesktopHeader;